module.exports = __webpack_public_path__ + "static/media/arrow-right-disabled.4c279ece.svg";